import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NotifierService } from 'src/app/_services/notifier.service';
@Component({
  selector: 'app-view-snap',
  templateUrl: './view-snap.component.html',
  styleUrls: ['./view-snap.component.css']
})
export class ViewSnapComponent implements OnInit {

  @Output() hideModal = new EventEmitter<any>();
  @Input() ebsList :any=[]

  constructor(public notifier: NotifierService) { }

  ngOnInit(): void {
    this.notifier.disableScroll();
  }
  no(){
    this.hideModal.emit({ status: 0 });
  }
  ngOnDestroy(): void {
    this.notifier.enableScroll();
}
}
